import React from 'react';
import Reflux from 'reflux';
import TimeUtil from 'time';
import classNames from 'classnames';
import CuesheetCueClockStore from 'flux/stores/cuesheet/CuesheetCueClockStore';
import { OverUnderStatuses } from 'shared/flux/stores/cuesheet/CuesheetConstants';
import PermissionStore from 'flux/stores/PermissionStore';
import { shallowEqualObjects } from 'shallow-equal';
const { OVER, UNDER } = OverUnderStatuses;

export default React.createClass({
  displayName: 'ActualDuration',

  mixins: [
    Reflux.connect(CuesheetCueClockStore, 'clock'),
    Reflux.connect(PermissionStore, 'permissions'),
  ],

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    displayActualDuration: React.PropTypes.bool,
    eventId: React.PropTypes.string,
    isTracked: React.PropTypes.bool,
    item: React.PropTypes.any.isRequired,
    user: React.PropTypes.object,
  },

  _getClockReading() {
    const state = this.state.clock;
    return state.get('reading') || 0;
  },

  shouldComponentUpdate(nextProps) {
    const { isTracked } = nextProps;
    if (isTracked || !shallowEqualObjects(this.props, nextProps)) {
      return true;
    }
    return false;
  },

  render() {
    const {
      actualDurationInSeconds,
      displayActualDuration,
      durationInSeconds,
      isTracked,
    } = this.props;

    const { clock } = this.state;

    const hasOverUnderPermission = this.state.permissions.get('overUnder');

    const display =
      displayActualDuration &&
      (actualDurationInSeconds !== undefined || isTracked);

    if (!hasOverUnderPermission || !display) {
      return null;
    }

    const durationDelta =
      isTracked && clock.get('ticking')
        ? this._getClockReading()
        : durationInSeconds - actualDurationInSeconds || 0;

    let status = '';
    if (durationDelta < 0) status = OVER;
    if (durationDelta > 0) status = UNDER;
    const formattedOverUnderDuration = TimeUtil.getFormattedOverUnderDuration(
      durationDelta,
    );

    const className = classNames(
      `cs-actual-duration-cell actual-duration-cell-${status}`,
      { 'actual-duration-cell-tracked': isTracked },
      { 'actual-duration-cell-zero': durationDelta === 0 },
    );

    return <div className={className}>{formattedOverUnderDuration}</div>;
  },
});
